import ApiService from './ApiService';

class GroupAdminApi extends ApiService {

    constructor() {
        super();
    }

    getStudentsOfCompanyByCourseStatus(payload) {
        return this.get('company', payload);
    }

    getAttendancesOfCompany(payload) {
        return this.get('company-attendance', payload);
    }

    // #17899 — 研修指定受講プラン dropdown: ticketplans of the group scope, optionally
    // narrowed down to a single selected attendance code.
    getTicketPlansForGA(payload) {
        return this.get('company-attendance/ticket-plans', payload);
    }

    getStudentsOfCompany(payload) {
        return this.get('user', payload);
    }

    getStudentDetail({ id, payload }) {
        return this.get(`user/${id}`, payload);
    }

    resignation({ id, payload }) {
        return this.post(`user/${id}/resignation`, payload)
    }

    getCourseListByStudent({ id, payload }) {
        return this.get(`${id}/company/courses`, payload);
    }

    getStudentListByAttendanceCode({ id, payload }) {
        return this.get(`company-attendance/${id}/list`, payload);
    }

    getTicketByGroup(payload) {
        return this.get('ticket-by-group', payload);
    }

    createCertificateExportJob(payload) {
        return this.post('course/attendance/export-pdf-job', payload);
    }

    getCertificateExportJobStatus(jobId) {
        return this.get(`course/attendance/export-pdf-job/${jobId}`);
    }

    getCertificateExportJobDownloadUrl(jobId) {
        return this.get(`course/attendance/export-pdf-job/${jobId}/download`);
    }

    exportStudentCSV(payload) {
        return this.post('export-csv', payload, null, 'blob');
    }

    updateStatusStudent({ id, payload }) {
        return this.put(`status/${id}`, payload);
    }

    getApprovalAttendanceCodes({ id }) {
        return this.get(`approval/${id}/attendance-codes`);
    }

    approveStudent({ id, payload }) {
        return this.put(`approval/${id}/approve`, payload);
    }

    rejectStudent({ id, payload }) {
        return this.put(`approval/${id}/reject`, payload);
    }

    updateStudentEmployeeCode({ id, payload }) {
        return this.put(`user/${id}/employee-code`, payload);
    }

    getCompanyAttendanceRate(payload) {
        return this.get('company-attendance-rate', payload);
    }

    // #17989 - the drill-down sends the bucket it belongs to (lt50 / gte50 / eq100) and the
    // paging state; the server resolves the learners itself (no more list of user ids in the URL state).
    getDetailCompanyAttendanceRate({ id, payload }) {
        const { bucket, ...paging } = payload || {};
        const query = new URLSearchParams(
            Object.entries(paging).filter(([, value]) => value !== null && value !== undefined && value !== '')
        ).toString();
        return this.post(`company-attendance-rate/${id}${query ? `?${query}` : ''}`, { bucket });
    }

    exportTestResultCsv(payload) {
        return this.post('export-test-result', payload, null, 'blob');
    }

    exportAttendanceStudentListCsv(payload) {
        return this.post('company-attendance/export-csv', payload, null, 'blob');
    }

    exportAttendanceCompleteRateCsv(payload) {
        return this.post('company-attendance-rate/export-csv', payload, null, 'blob');
    }

    getAllChildrenGroupById(id) {
        return this.get(`group/${id}`);
    }

    getCompanyDepartments() {
        return this.get('company-departments');
    }

    getTestHistoriesByStudent(payload) {
        const { id, ...rest } = payload
        return this.get(`user/test-history-ei/${id}`, rest);
    }
    getCalculateAverageEi(payload) {
        const { id } = payload
        return this.get(`/user/calculate-average-ei/${id}`);
    }
}

export default GroupAdminApi;